var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    textAlign: _vm.textAlign,
    width: _vm.width + '%',
    margin: _vm.margin,
    position: 'relative'
  })},[(_vm.errorMessage)?_c('p',{staticClass:"red--text field-error"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_c('label',{style:([_vm.labelStyles])},[_vm._v(_vm._s(_vm.labelTitle))]),(_vm.required)?_c('span',{staticClass:"pink--text"},[_vm._v("*")]):_vm._e(),(_vm.unit && _vm.unitFirst)?_c('div',{staticClass:"input-unit-head"},[_c('span',[_vm._v(_vm._s(_vm.unit.toUpperCase()))])]):_vm._e(),(_vm.unitIcon && _vm.unitFirst)?_c('div',{staticClass:"input-unit-head"},[_c('span',{staticClass:"icon",style:({
        backgroundImage: ("url(" + (require(("@/assets/icons/" + _vm.unitIcon + ".svg"))) + ")"),
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100%'
      })})]):_vm._e(),_c('input',{style:([
      _vm.unit || _vm.unitIcon
        ? _vm.unitFirst
          ? {
              height: _vm.height + 'px',
              paddingLeft: '3rem'
            }
          : {
              height: _vm.height + 'px',
              paddingRight: '5rem'
            }
        : {
            height: _vm.height + 'px'
          },
      _vm.inputStyles
    ]),attrs:{"autocomplete":"off","placeholder":_vm.placeholder,"required":_vm.required,"disabled":_vm.disabled,"max":_vm.maxDate != null ? _vm.maxDate : null,"step":_vm.step,"type":_vm.type === 'password' ? (_vm.showPassword ? 'input' : 'password') : _vm.type},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),(_vm.type === 'password')?_c('div',{staticClass:"input-unit-end",on:{"click":function($event){_vm.showPassword = !_vm.showPassword}}},[_c('img',{staticClass:"eye-icon",attrs:{"src":require('@/assets/icons/eye-' +
          (_vm.showPassword ? 'blue' : 'pink') +
          '.svg')}})]):_vm._e(),(_vm.unit && !_vm.unitFirst)?_c('div',{staticClass:"input-unit-end"},[_c('span',[_vm._v(_vm._s(_vm.unit.toUpperCase()))])]):_vm._e(),(_vm.unitIcon && !_vm.unitFirst)?_c('div',{staticClass:"input-unit-end"},[_c('span',{staticClass:"icon",style:({
        backgroundImage: ("url(" + (require(("@/assets/icons/" + _vm.unitIcon + ".svg"))) + ")"),
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100%'
      })})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }